import { trackObject } from '@utils/tracking';

export const partnerClickout = ({ prn }) =>
  trackObject({
    event: `home_click-header-ad`,
    category: 'home',
    action: 'click header ad',
    label: prn,
  });
